import React from "react";
import { Label } from "semantic-ui-react";
import { InspectionStatus, InspectionStatuses } from "./citizen-inspection-list/constants/InspectionStatus";
import { InspectionStatusColor } from "./citizen-inspection-list/constants/InspectionStatusColor";

export default function InspectionStatusLabel({ status }: { status: InspectionStatus }) {
  return (
    <Label
      size={"large"}
      circular
      basic={status === InspectionStatuses.UNSCHEDULED || status === InspectionStatuses.REQUESTED}
      color={InspectionStatusColor[status]}
      className={status === InspectionStatuses.REQUESTED ? "tw-border-[#6F4D17] tw-bg-[#fffaf3] tw-text-[#6F4D17]" : ""}
    >
      {status ? `${status[0].toUpperCase()}${status.slice(1)}` : status}
    </Label>
  );
}
